import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';




function AllUsersPage(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllUsers, setAllUsers] = useState([]);

    axios.defaults.withCredentials = true;


    const GetAllUsers = ()=>{
        axios.post('AllItems', {
            table: 'admins',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllUsers(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    

    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }


    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'admins',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
            GetAllUsers();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };
    
    const activateItem = (id) => {
        axios
        .put(`/activate-item/${id}`, {
            table: 'admins',
        })
        .then((response) => {
            if (response.data.message === 'Item Activating successfully') {
            GetAllUsers();
            } else {
            console.error('Failed to activate result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error activating result:', error);
        });
    };
    


useEffect(() => {

    GetAllUsers();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <Link className='new-item' to='/add-user'> + New user</Link>
                <table>

                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Options</th>
                            <th>Delete</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllUsers.length ? (

                    AllUsers.map(user => {
                        return (
                            <tr key={user.id}>
                            <td><h6>{user.id}</h6></td>
                            <td><h2>{user.username}</h2></td>
                            <td><Link className='edit' to={`/edit-user?id=${user.id}`}> <i class="las la-edit"></i> </Link></td>
                            <td><button className='delete' onClick={() => deleteItem(user.id)}> <i class="las la-trash-alt"></i> </button></td>
                            
                            </tr>
                        );
                        })): (
                            <tr>
                                <td colSpan={5}>Loading...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllUsersPage;